import { FoodTypesDto } from "@gtpl/shared-models/masters";
import { ValueAdditionOneType } from "../value-addition-one.entity";
import { ValueAdditionOneDTO } from "./value-addition-one.dto";

export class ValueAddOneTypeAdapter {
    convertDtoToEntity(dtoObj: ValueAdditionOneDTO,  isUpdate: boolean = false ): ValueAdditionOneType {
        try {
            const entityObj = new ValueAdditionOneType();
            entityObj.createdUser = dtoObj.createdUser;
            entityObj.code = dtoObj.code;
            entityObj.name = dtoObj.name;
            entityObj.remarks = dtoObj.remarks;
            if (dtoObj.valueAdditionOneId) {
                entityObj.valueAdditionOneId = dtoObj.valueAdditionOneId;
                entityObj.updatedUser = dtoObj.updatedUser;
            }
            entityObj.isActive = dtoObj.isActive;
            return entityObj;
        } catch (Error) {
            throw Error;
        }
    }

    public convertEntityToDto(employeeObject: ValueAdditionOneType): ValueAdditionOneDTO {
        const foodTypeDetailsDTO= new ValueAdditionOneDTO;
        foodTypeDetailsDTO.valueAdditionOneId = employeeObject.valueAdditionOneId;
        foodTypeDetailsDTO.code = employeeObject.code;
        foodTypeDetailsDTO.name = employeeObject.name;
        foodTypeDetailsDTO.remarks = employeeObject.remarks;
        foodTypeDetailsDTO.isActive = employeeObject.isActive;
        foodTypeDetailsDTO.createdAt = employeeObject.createdAt;
        foodTypeDetailsDTO.updatedAt = employeeObject.updatedAt;
        foodTypeDetailsDTO.createdUser = employeeObject.createdUser;
        foodTypeDetailsDTO.updatedUser = employeeObject.updatedUser;
        foodTypeDetailsDTO.versionFlag = employeeObject.versionFlag;
        return foodTypeDetailsDTO;
      }
}